<div class="container">
  <div class="search-container">
      <input type="text" class="search-input" placeholder="Search for anything..." [(ngModel)]="search">
      <select [(ngModel)]="searchType" class="search-dropdown">
          <option [value]="search" *ngFor="let search of searchTypes">{{ search }}</option>
      </select>
      <button class="search-button" (click)="searchProduct()">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="11" cy="11" r="8"></circle>
              <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
          </svg>
      </button>
  </div>

  <div>
    <button mat-raised-button type="button" color="primary" (click)="scanCode()" *ngIf="platform !== 'web'">Scan</button>
    <a mat-raised-button type="button" color="primary" *ngIf="platform === 'web'" href="https://play.google.com/apps/internaltest/4701150229991970065">Android</a>
  </div>

</div>